export const RiskScoreLabelTypes = {
    WORKFLOW: "workflow",
    MANUAL: "manual",
    COMPUTED: "computed",
    RISK_SCORE: "risk_score",
}

export const riskLabelTypeMap = {
    CASE: "Case",
    ENTITY: "Entity",
    RISK_CATEGORY: "risk_category",
  }
  
  export const editLabelMode = {
    EDIT: "edit",
    CREATE: "create",
  }
  
  export const riskLabelTypePropertyMap = {
      [riskLabelTypeMap.CASE]: 'caseMode',
      [riskLabelTypeMap.ENTITY]: 'entityMode',
      [riskLabelTypeMap.RISK_CATEGORY]: 'categoryMode',
  }
  
  export const riskScoreBasedValueMap = {
    risk_score: true,
    workflow: false,
  }
  
  export const labelSourceTypeMap = {
    RISK_SCORE: 'risk_score',
    WORKFLOW: 'workflow',
    MANUAL: 'manual',
  };
